<template>
  <!-- 用户列表 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form
        ref="form"
        :model="searchParams"
        label-width="auto"
        class="from"
        label-position="right"
      >
        <el-form-item :label="$t('pages.user.text1')">
          <el-input
            v-model="searchParams.mail"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.user.text2')">
          <el-input
            v-model="searchParams.phone"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.user.text3')">
          <el-input
            v-model="searchParams.city"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('omission.text64')">
          <el-select
            v-model="searchParams.bindState"
            :placeholder="$t('public.text5')"
          >
            <el-option :label="$t('omission.text65')" :value="0"> </el-option>
            <el-option :label="$t('omission.text66')" :value="1"> </el-option>
            <el-option :label="$t('omission.text67')" :value="2"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('omission.text70')">
          <el-select
            v-model="searchParams.lockState"
            :placeholder="$t('public.text5')"
          >
            <el-option :label="$t('omission.text68')" :value="1"> </el-option>
            <el-option :label="$t('omission.text69')" :value="0"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('pages.user.text4')">
          <el-date-picker
            v-model="searchParams.startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            @change="startChange"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
          <span style="margin: 0 14px">-</span>
          <el-date-picker
            v-model="searchParams.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton type="search" @click="search" v-permission="['userList:query']"></DiluButton>
        <DiluButton type="reset" @click="reset" v-permission="['userList:reset']"></DiluButton>
      </div>
    </div>
    <!-- 表格 -->
    <DiluTable :list="tableData" :tableConfig="tableConfig" :pageSize="searchParams.pageSize" @currentChange="currentChange" :total="total">
      <el-table-column prop="id" label="ID" align="center" min-width="80"/>
      <el-table-column prop="appAccount" :label="$t('pages.user.text5')" align="left" width="250" />
      <el-table-column prop="city" :label="$t('pages.user.text3')" align="left" width="220">
        <template slot-scope="scope">
          <span>{{ scope.row.city ? scope.row.city : "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="clientType" :label="$t('omission.text63')" align="center" width="150"/>
      <el-table-column prop="appVersion" :label="$t('menu.appVersion')" align="center" width="100"/>
      <el-table-column prop="createdAt" :label="$t('pages.user.text4')" align="center" width="180" />
      <el-table-column prop="totalDistance" :label="$t('pages.user.text6')" align="center" width="150"/>
      <el-table-column prop="address" :label="$t('public.text4')" align="center" fixed="right" width="200">
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="refreshInfo(scope.row)" type="text" v-permission="['userList:refresh']">{{ $t("button.refresh") }}</el-button>
            <el-button @click="userInfo(scope.row)" type="text" v-permission="['userList:info']">{{ $t("button.look") }}</el-button>
            <el-button @click="remove(scope.row)" type="text" v-permission="['userList:remove']">{{ $t("pages.operate.text5") }}</el-button>
          </div>
        </template>
      </el-table-column>
    </DiluTable>
  </div>
</template>

<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import { mapState } from "vuex";
import { resetDate } from "../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.searchParams.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      searchParams: {
        city: "", //城市
        mail: "", //邮箱
        phone: "", //手机号
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
        bindState: null,
        lockState: null,
      },
      dialogVisible: false, //新增编辑弹窗
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      total: 0,
      options: [],
      tableData: [],
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluTable,
    DiluButton,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {
    this.userList();
  },
  methods: {
    //禁用
    remove(e) {
      this.$confirm(this.$t("omission.text62"), this.$t("public.text6"), {
        confirmButtonText: this.$t("button.determine"),
        cancelButtonText: this.$t("button.cancel"),
        type: "warning",
      })
        .then(() => {
          this.request.userListDelete(e.id).then(() => {
            this.userList();
            this.$message({
              type: "success",
              message: this.$t("public.text7"),
            });
          });
        })
        .catch(() => {});
    },
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.userList();
    },
    startChange() {
      this.searchParams.stopAt = null;
    },
    //获取网络升级任务列表
    userList() {
      if (this.searchParams.stopAt && this.searchParams.startAt) {
        this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 结束时间
        this.searchParams.startAt = resetDate(this.searchParams.startAt); // 开始时间
      }
      if (this.searchParams.startAt) {
        if (!this.searchParams.stopAt) {
          return this.$message.error(this.$t("public.text3"));
        }
      }
      if (this.searchParams.stopAt) {
        if (!this.searchParams.startAt) {
          return this.$message.error(this.$t("public.text4"));
        }
      }
      if (this.platformData.platformCode == "superAdmin") {
        this.searchParams.belongCustomerId = "" + this.platformData.id;
        this.searchParams.appCode = this.platformData.appCode;
      }
      this.request
        .userList(this.searchParams)
        .then((res) => {
          this.tableData = res.data;
          this.total = res.dataMaxCount;
        })
        .catch(() => {});
    },
    // 重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        belongCustomerId: "", //平台方id
        city: "", //城市
        mail: "", //邮箱
        phone: "", //手机号
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
      };
      this.total = 0;
      this.userList();
    },
    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams = {
          belongCustomerId: "", //平台方id
          city: "", //城市
          mail: "", //邮箱
          phone: "", //手机号
          pageNum: 1, //页码
          pageSize: 10, //每页条数
          startAt: "", //查询开始时间
          stopAt: "", //查询结束时间
        };
      }
      this.searchParams.pageNum = e;
      this.userList();
    },
    //关闭新增编辑弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    //新增
    add() {
      this.dialogVisible = true;
    },
    //查看用户详情
    userInfo(e) {
      let currentUser = {
        appAccount: e.appAccount,
        nickname: e.nickname,
        createdAt: e.createdAt,
        city: e.city,
        id: e.id,
        headImg: e.headImg,
      };
      this.$router.push({
        path: "/user/userCenter/userInfo",
        query: {
          currentUser: JSON.stringify(currentUser),
        },
      });
    },
    //刷新用户信息
    refreshInfo(e) {
      this.request
        .userRefresh({userId:e.id})
        .then((res) => {
          if (res.code==0) {
            this.userList();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
  flex-wrap: wrap;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>